import ReactAnimatedNumber from 'react-animated-number';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} AnimatedNumberProps
 * @property {number} [value]
 * @property {number} [fontSize]
 * @property {(n: number) => React.ReactNode} [formatValue]
 * @property {number} [stepPrecision]
 */

/** @type {React.FC<AnimatedNumberProps>} */
const AnimatedNumber = ({
  fontSize = 34,
  value = 0,
  formatValue = n => n,
  stepPrecision = 0,
}) => {
  return (
    <ReactAnimatedNumber
      style={{
        fontSize,
        transition: '0.5s ease-out',
        transitionProperty: 'background-color, color, opacity',
      }}
      stepPrecision={stepPrecision}
      duration={850}
      value={value}
      formatValue={formatValue}
    />
  );
};

AnimatedNumber.propTypes = {
  value: PropTypes.number.isRequired,
  fontSize: PropTypes.number,
  formatValue: PropTypes.func,
  stepPrecision: PropTypes.number,
};

export default AnimatedNumber;
